import { createSlice } from '@reduxjs/toolkit'
import {
  changeStatus,
} from './controlPanelThunks' 
import { set } from 'date-fns'

const initialState = {
    openModal: null,
    guestInvitationEnabled: false,
    userToVisitMapId:'',
    changeMapType:'',
    menuIsOpen:false,
    testModal:null,
    mattermostChatEnabled: false,
}


const controlPanelSlice = createSlice({
  name: 'controlPanel',
  initialState,
  reducers: {
    setOpenModal: (state, action) => {
      // Auto toggle the modal state
      // If the action payload is the same as the current state, close the modal
      state.openModal = action.payload === state.openModal ? null : action.payload
    },
     setGuestInvitationEnabled: (state, action) => {
      state.guestInvitationEnabled = action.payload.enabled
    },
    setUserToVisitMapId: (state, action) => {
      state.userToVisitMapId = action.payload;
    },
    setChangeMapType: (state, action) => {
      state.changeMapType = action.payload;
    },
    setMenuIsOpen: (state, action) => {
    state.menuIsOpen = action.payload;
    },
    setTestModal: (state, action) => {
      state.testModal = action.payload;
    },
    setMattermostChatEnabled: (state, action) => {
    state.mattermostChatEnabled = action.payload.enabled;
},
  },
  extraReducers : (builder) => {
    builder
      .addCase(changeStatus.fulfilled, (state, action) => {
       console.log("update status success")
      })
      .addCase(changeStatus.rejected, (state, action) => {
        state.error = action.payload || 'Failed to change status';
      })
  },


})

export const {
  setOpenModal ,
  setGuestInvitationEnabled,
  userToVisitMapId,
  setUserToVisitMapId,
  setChangeMapType,
  changeMapType,
  setMenuIsOpen,
  setTestModal,
  setMattermostChatEnabled
} = controlPanelSlice.actions




export default controlPanelSlice.reducer